import { render, staticRenderFns } from "./Share2.vue?vue&type=template&id=3cf416a9&"
import script from "./Share2.vue?vue&type=script&lang=js&"
export * from "./Share2.vue?vue&type=script&lang=js&"
import style0 from "./Share2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports